export default "__VITE_ASSET__8lU6XMXp__"